import { useRef, useEffect, useState } from 'react';
import { ISelectInfo, ICategortItem, IProductItem } from '../cacl';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFArrowRightBlueSmall from '@/components/UI/svg/Icons/EFArrowRightBlueSmall';

interface progressItem {
    key: keyof ISelectInfo;
    label: string;
    selectStep: string;
    active: boolean;
    selected: boolean;
}
interface IProps {
    data: progressItem[];
    productList: ICategortItem[];
    solarTypeList: any;
    selectInfo: ISelectInfo;
}

export default function Progress({ data, productList, solarTypeList, selectInfo }: IProps) {
    const { useLang, useRouter, isMobile } = useGlobal();
    const ref = useRef<any>(null);
    const router = useRouter();
    const { locale, query } = router;
    const { step: pageStep } = query;
    const { t } = useLang('calculatorssolarpanels');

    const back = () => {
        switch (pageStep) {
            case '3':
                router.push({
                    pathname: `/${locale}/calculators/solarpanels`,
                    query: {
                        step: '2',
                    },
                });
                break;
            case '2':
                router.push({
                    pathname: `/${locale}/calculators/solarpanels`,
                });
                break;
            default:
                break;
        }
    };

    const getProductName = (productList: ICategortItem[], key: string) => {
        const allProducts = productList.reduce<IProductItem[]>((p, c) => p.concat(c.list), []);
        return allProducts.find((product) => product.key === key)?.productName;
    };

    const handleTransformData = (data: progressItem[]): progressItem[] => {
        const { activeStep } = selectInfo;

        return data.map((item) => {
            const selectValue = selectInfo[item.key];
            const active = activeStep === Number(item.selectStep);
            const selected = activeStep > Number(item.selectStep) && !!selectValue;

            if (!selectValue || (!selected && !active)) return { ...item, selected, active };
            let newLabel;
            switch (item.key) {
                case 'productkey':
                    newLabel = getProductName(productList, selectValue) || selectValue;
                    if (!pageStep) newLabel = item.label;
                    break;
                case 'chargTime':
                    newLabel = selectValue + t('cacl_step2_recharge_time_unit');
                    break;
                case 'solarType':
                    newLabel = solarTypeList.find((item: any) => item.type === selectValue)?.text || selectValue;
                    break;
                default:
                    break;
            }
            return {
                ...item,
                label: newLabel,
                selected,
                active,
            };
        });
    };

    // 移动端找到当前选择的
    const getLastSelected = (data: progressItem[]) => {
        const length = data.length;
        for (let index = length - 1; index >= 0; index--) {
            const element = data[index];
            if (element.active) {
                if (pageStep === '3') return {};

                const prevElement = data[index - 1];
                if (selectInfo[element.key]) {
                    return element;
                } else if (prevElement?.selected) {
                    return prevElement;
                } else {
                    return element;
                }
            }
        }
    };

    //const transformData = handleTransformData(data);
    //const lastSelected = getLastSelected(transformData);

    const [transformData, setTransformData] = useState([]);
    const [lastSelected, setLastSelected] = useState({});

    useEffect(() => {
        setTransformData(handleTransformData(data));
        setLastSelected(getLastSelected(transformData));
    }, []);

    return (
        <div className={css.calc_progress}>
            <div className="progress-container">
                <div className="progress">
                    {transformData?.map((item, index) => (
                        <div key={item.key} className={`progress_item ${item.selected ? 'selected' : ''} ${item.active ? 'active' : ''}`}>
                            <div className="line">{index === 0 && item.active && <div className="sub-line"></div>}</div>
                            <div className="text-content">
                                <span className="text">{item.label}</span>
                            </div>
                        </div>
                    ))}
                    <div className="result-content">
                        <span className={selectInfo.activeStep === 4 ? 'active' : ''}>Result</span>
                    </div>
                </div>
                {/* 手机端展示选择 */}
                {isMobile && <div className="last-selected">{lastSelected?.label || 'Result'}</div>}
                {!!pageStep && !isMobile && (
                    <div className="back" onClick={back}>
                        <EFArrowRightBlueSmall /> Back
                    </div>
                )}
            </div>
        </div>
    );
}
